import { Contact } from "../../types/Contact";
import { isDefined } from "../../Utils/utils";
import { ajaxActions } from "../AjaxActions";

const BASE_URL = process.env.REACT_APP_SHARE_SERVICE_URL;

export const fetchContact = (contactId: any, resourceId: any) =>
  ajaxActions
    .get(BASE_URL + "/contacts/" + contactId + "?resourceId=" + resourceId)
    .then((resp) => {
      return resp;
    });

const edit = async (
  id: number,
  patch: Partial<Contact>,
  profileId: number
): Promise<Contact | null> => {
  const res = await ajaxActions.patch(
    `${BASE_URL}/contacts/${id}?profileId=${profileId}`,
    patch
  );
  if (res.ok) {
    return res.json();
  }
  return null;
};

const isAddressAndPartnerDefined = (contact: Contact) => {
  const addressDefined = isAddressDefined(contact);
  const partnerDefined = partnerFullNameDefined(contact);
  return addressDefined && partnerDefined;
}

const isAddressDefined = (contact: Contact) => {
  const { addressStreetAndNo, zipCode, city } = contact;
  return isDefined(addressStreetAndNo) && isDefined(zipCode) && isDefined(city);
};

const partnerFullNameDefined = (contact: Contact) => {
  const { partner } = contact;
  // only checking, if partner is defined at all
  if (!partner) { return true; }
  return partner && (isDefined(partner.firstName) && isDefined(partner.lastName));
};

export const ContactS = {
  edit,
  isAddressAndPartnerDefined,
};
